(function () {
  const BREAKPOINT = 576;

  const initSlider = (section) => {
    const container = section.querySelector(".product-review-container");
    const slider = section.querySelector(".swiper--product-review");

    // Nothing to do, or already initialised
    if (!container || !slider || slider.swiper) return;

    // Swiper is expected to be loaded by the theme; retry once everything has loaded
    if (typeof Swiper === "undefined") {
      window.addEventListener("load", () => initSlider(section), { once: true });
      return;
    }

    slider.querySelectorAll(".reviews-products__item").forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    // data-space-between lives on .product-review-container (e.g. "2.4" -> 24px)
    const spaceBetween = container.dataset.spaceBetween
      ? Number(container.dataset.spaceBetween) * 10
      : 24;

    const spaceBetweenMobile = slider.classList.contains(
      "swiper--product-review--visible-overflow"
    )
      ? 16
      : 20;

    // Optional controls (not in the current Liquid, only used if you add them)
    const nextBtn = section.querySelector(".multicolumn-button--next");
    const prevBtn = section.querySelector(".multicolumn-button--prev");
    const scrollbar = section.querySelector(".swiper-scrollbar");

    const options = {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: spaceBetweenMobile,
      speed: 800,
      mousewheel: { forceToAxis: true },
      watchSlidesProgress: true,
      breakpoints: {
        [BREAKPOINT]: { spaceBetween: spaceBetween },
      },
    };

    if (nextBtn && prevBtn) {
      options.navigation = {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "multicolumn-button--disabled",
      };
    }

    if (scrollbar) {
      options.scrollbar = {
        el: scrollbar,
        draggable: true,
        hide: false,
      };
    }

    new Swiper(slider, options);
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--product-review");
    if (slider?.swiper) {
      // (deleteInstance, cleanStyles) removes inline styles Swiper added
      slider.swiper.destroy(true, true);
    }
  };

  const initSection = (section) => {
    if (!section || section.dataset.reviewsInit === "true") return;

    // Data attributes are on .product-review-container, not the wrapper
    const container = section.querySelector(".product-review-container");
    if (!container) return;

    section.dataset.reviewsInit = "true";

    const hasMobileSlider = container.dataset.enableMobileSlider === "true";
    const hasDesktopSlider = container.dataset.enableDesktopSlider === "true";

    const update = (width) => {
      const enabled = width < BREAKPOINT ? hasMobileSlider : hasDesktopSlider;
      if (enabled) {
        initSlider(section); // no-op if a Swiper instance already exists
      } else {
        destroySlider(section);
      }
    };

    const observer = new ResizeObserver((entries) => {
      update(entries[0].contentRect.width);
    });

    observer.observe(section);
  };

  const initAll = (root) => {
    (root || document)
      .querySelectorAll(".reviews-products-section")
      .forEach(initSection);
  };

  // The script tag sits inside the section, so don't rely on currentScript.parentElement.
  // Find every matching section on the page instead.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  // Register the theme editor listener only once, even if the script runs per section
  if (!window.__reviewsProductsListener) {
    window.__reviewsProductsListener = true;
    document.addEventListener("shopify:section:load", (event) => {
      initAll(event.target);
    });
  }
})();